<!-- <div *ngIf="showSplash" class="splash">
  <div class="splash-spinner"></div>
</div> -->

<ion-app>
  <ion-split-pane when="md" contentId="menu-content" [disabled]="chromeless()">

    <!-- Design-system nav rail (replaces the hand-rolled ion-menu tree).
         Role/appMode filtering + i18n happen in app.component.ts -> navItems$. -->
    <app-kz-nav-rail
      *ngIf="currentUser && !chromeless()"
      [items]="(navItems$ | async) || []"
      contentId="menu-content"
      [navLabel]="'a11y.mainMenu' | translate"
      (navItemClick)="onNavItemClick($event)">
    </app-kz-nav-rail>

    <!-- iOS swipe-back is off on a chromeless (public) screen — the locked kiosk refuses to leave, and a refused swipe
         can leave the page underneath showing (kzd r1 §16 item 26). -->
    <ion-router-outlet id="menu-content" [swipeGesture]="swipeBack()"></ion-router-outlet>
  </ion-split-pane>

  <!-- A navigation in flight (guards, a lazy module) — never a blank page (kz2 M7 dev check). -->
  @if (routeLoading()) {
    <div class="route-loading" role="status" aria-live="polite">
      <ion-spinner name="crescent"></ion-spinner>
      <span class="kz-sr">{{ 'common.loading' | translate }}</span>
    </div>
  }

  <!-- kzd-ac AC-R6: the minimum-version gate (core/update-gate) — over everything; the app keeps sending underneath. -->
  @if (updateRequired()) {
    <app-kz-update-required></app-kz-update-required>
  }
</ion-app>
